import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { GetApiUsersMe200, PermissionApiDTO } from '../codegen/generated/Api.schemas'
import { UsersHelper } from '../helpers/Users.helper'
import { ICMS, IYoutubeCMS } from '../types/CMS'

export const CMS_LIST: ICMS[] = [
  { id: 'logicomix', name: 'Logicomix' },
  { id: 'bump', name: 'Bump' },
  { id: 'tv5monde', name: 'TV5 Monde' },
  { id: 'france_tv_medias', name: 'France TV Médias' },
  { id: 'endemol', name: 'BMF' },
]

export const YOUTUBE_CMS_LIST: IYoutubeCMS[] = [
  { id: 'Logicomix', name: 'Logicomix' },
  { id: 'Logicomix Network', name: 'Logicomix Network' },
  { id: 'BUMP', name: 'Bump' },
  { id: 'TV5 Monde', name: 'TV5 Monde' },
  { id: 'France TV Médias', name: 'France TV Médias' },
  { id: 'endemol', name: 'BMF' },
]

type UserStoreType = {
  me: GetApiUsersMe200 | undefined
  getCMSList: () => ICMS[]
  getYoutubeCMSList: () => IYoutubeCMS[]
  isAuthorised: (permission: PermissionApiDTO | PermissionApiDTO[]) => boolean
  isAuthorisedOneOf: (permissions: PermissionApiDTO[]) => boolean
}

const AUTH_KEY = 'lx-user'

export const useUserStore = create(
  persist<UserStoreType>(
    (_, get) => ({
      me: undefined,
      getCMSList: () => {
        const { me } = get()

        if (me?.scopes?.cms[0] === '*') {
          return CMS_LIST
        }

        return CMS_LIST.filter(cms => me?.scopes?.cms.includes(cms.id))
      },
      getYoutubeCMSList: () => {
        const { me } = get()

        if (me?.scopes?.cms[0] === '*') {
          return YOUTUBE_CMS_LIST
        }

        return YOUTUBE_CMS_LIST.filter(cms => {
          if (cms.id === 'Logicomix' || cms.id === 'Logicomix Network') {
            return me?.scopes?.cms.includes('logicomix')
          }

          if (cms.id === 'BUMP') {
            return me?.scopes?.cms.includes('bump')
          }

          if (cms.id === 'TV5 Monde') {
            return me?.scopes?.cms.includes('tv5monde')
          }

          if (cms.id === 'France TV Médias') {
            return me?.scopes?.cms.includes('france_tv_medias')
          }

          return me?.scopes?.cms.includes(cms.id)
        })
      },
      isAuthorised: permissions => {
        const { me } = get()

        if (me?.roles?.some(r => r.id === UsersHelper.ADMIN_ROLE)) {
          return true
        }

        if (typeof permissions === 'string') {
          return !!me?.roles?.some(r => r.permissions.includes(permissions))
        }

        return permissions.reduce(
          (_, perm) => !!me?.roles?.some(r => r.permissions.includes(perm)),
          false,
        )
      },
      isAuthorisedOneOf: permissions => {
        const { me } = get()

        if (me?.roles?.some(r => r.id === UsersHelper.ADMIN_ROLE)) {
          return true
        }

        return permissions.some(p => !!me?.roles?.some(r => r.permissions.includes(p)))
      },
    }),
    { name: AUTH_KEY },
  ),
)
